import { useEffect } from 'react';

type SeoProps = {
  title: string;
  description: string;
  path?: string;
};

function setMeta(selector: string, attribute: 'content', value: string) {
  const element = document.head.querySelector(selector);
  if (element) {
    element.setAttribute(attribute, value);
  }
}

export default function Seo({ title, description, path = '/' }: SeoProps) {
  useEffect(() => {
    const fullTitle = `${title} | DropBridge`;
    const url = `${window.location.origin}${path}`;

    document.title = fullTitle;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', description);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;
  }, [description, path, title]);

  return null;
}
